module.exports = __webpack_public_path__ + "static/img/icon_zanwufbwz.f75aceb0.png";